import { render } from "./PlatMerchantEmployees.vue?vue&type=template&id=688cc12c&scoped=true"
import script from "./PlatMerchantEmployees.vue?vue&type=script&lang=js"
export * from "./PlatMerchantEmployees.vue?vue&type=script&lang=js"

import "./PlatMerchantEmployees.vue?vue&type=style&index=0&id=688cc12c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688cc12c"]])

export default __exports__